import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import RootModal from 'components/interactive/stories/root-modal'

const Modal = styled.div`
	user-select: none;
	position: absolute;
	width: 300px;
	min-height: 150px;
	background-color: white;
	border: 5px solid black;
	border-radius: 5px;
	padding: 10px 30px 40px 30px;
`;

const ModalPosition = styled.div`
	z-index: 7;
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${props=>props.color ? props.color : "rgba(255,218,185,0.6)"};
`;

class FullScreenModal extends React.Component{

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    document.body.classList.add("stopscroll")
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
    document.body.classList.remove("stopscroll");
  }
  handleKeyDown = (event) => {
    if(event.key === 'Escape') {
      this.props.onToggleVisibility(false)
    }
  }
	//-- RootModal used to go full screen on this puppy
	//-- stopPropagation() allows clicks to matter on the parent, but not on the child (like a enahnceWithClickOutside)
	render() {
		return(
	    <RootModal>
    		<ModalPosition
    			color={this.props.overlayColor}
    			onClick={()=>this.props.onToggleVisibility(false)}
  			>
	    		<Modal onClick={(e)=>{e.stopPropagation()}}>
	    			{this.props.children}
	    		</Modal>
	  		</ModalPosition>
	    </RootModal>
	  )
	}
}

FullScreenModal.propTypes = {
	overlayColor: PropTypes.string,
	onToggleVisibility: PropTypes.func.isRequired,
}

export default FullScreenModal;



// WEBPACK FOOTER //
// ./src/components/static/FullScreenModal.js